import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import { Search } from "@mui/icons-material";
import { IconButton} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';


  const RedButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: "#ff0000",
    '&:hover': {
      backgroundColor: "#8b0000",
    },
  }));

  export default function NewKlienPopUp({handleClose, selectedPost,connectClose, handleCloseNoTelp,handleCloseNewCompany,selectNamaPerusahaan, setcompanyID, companies, handleCompany2, setCompanies, handleClosePreview,closechangePerusahaanPopUPOpen, setContractData, contractData}){
    const [namaPerusahaan,setNamaPerusahaan] = useState("")
    const [error,setError] = useState("")

    const [industri,setIndustri] = useState(["..."])


    const [ktp,setKTP] = useState("")
    const [npwp,setNPWP] = useState("")
    const [email,setEmail] = useState([""])
    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredCompany, setIsHoveredCompany] = useState(false);
    const [tipePerusahaan, setTipePerusahaan] = useState("");
    
    const handleNamaPerusahaan = (event) => {
      const value = event.target.value;
      let updatedValue = value;
      let updatedTipePerusahaan = tipePerusahaan;
    
      const regex = /^(pt|cv)\.\s+/i;
    
      if (value.match(regex)) {
        updatedValue = value.replace(regex, "");
        updatedTipePerusahaan = value.match(/^(pt|cv)/i)[0].toUpperCase();
      }
    
      setNamaPerusahaan(updatedValue);
      setTipePerusahaan(updatedTipePerusahaan);
      event.target.value = updatedValue; // Update the input field value
      
    };
    
    
    
    
    
    
    const handleIndustri = (event) => {
        const values =[...industri];
        values[0] = event.target.value;
        setIndustri(values);
    }
    const handleCompany = (post, idid) => {
      console.log(post.namaPerusahaan)
      console.log("idid"+idid)
        const values =[...companies];
        values[0].NamaPT = post.namaPerusahaan;
        values[0].CompanyID= idid;
        setCompanies(values);
    }
    const handleKTP = (event) => {
        setKTP(event.target.value);
    }
    const handleNPWP = (event) => {
      let value = event.target.value;
value = value.replace(/\D/g, ""); // Remove any non digit character
value = value.replace(/^(\d{2})(\d)/, "$1.$2");
value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})-(\d{1})(\d)/, "$1.$2.$3-$4.$5");
value = value.slice(0,20); // Limit length to 15 digits and 5 special characters (20 in total)
      setNPWP(value);
    };
    const handleEmail = (event) => {
        const values =[...email];
        values[0] = event.target.value;
        setEmail(values);
        console.log(email);
    }

  async function saveCompany(e) {
    console.log(selectedPost)
      if (tipePerusahaan === "" || namaPerusahaan === "" || industri[0] === "" || npwp === "") {
        console.log("gagal ada data kurang");
      } else {
        const regex = /^(PT\.|CV\.)\s+/i;
        const formattedNamaPerusahaan = namaPerusahaan.replace(regex, "");
        
        console.log(industri);
        console.log("sending data to backend");
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveCompanyQuick`, {
            tipePerusahaan,
            namaPerusahaan: formattedNamaPerusahaan,
            industri,
            npwp,
            noNib,
            akte,
          })
          .then((response) => {
            const company = response.data
            console.log(namaPerusahaan)
            console.log(response.data._id)
            const idid = response.data._id;
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/latestKontrakNum`)
            .then(response => {
              console.log(response.data);
              console.log(response.data.jumlah);
              var testestest = response.data.jumlah;
              console.log(testestest);
              var piAmountNow = parseInt(testestest) + 1;
              console.log(piAmountNow);
              var tanggalAwal = new Date(selectedPost.TanggalMulai)
              var piMonth = new Date(tanggalAwal).getMonth() + 1
              var piYear = new Date(tanggalAwal).getYear() + 1900
              var piDate = new Date(tanggalAwal).getDate()
              var PINumbnow = piYear + "." + piMonth + "-Kontrak-Zanio." + piAmountNow;
              console.log({ PINumbnow, piAmountNow });
          
              return axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveTempToKontrakVO`, {
              piAmountNow, PINumbnow, selectedPost, idid, namaPerusahaan, tipePerusahaan, industri, npwp, noNib, akte, company
              })
              .then(response => {
                console.log(response.data._id)
                const kontrakid = response.data._id; // extract _id from response
                console.log("Ini PINUMBNOW yang mau di render "+PINumbnow)
                return axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`, {
                  id: kontrakid // include _id here
                }, {
                  responseType: "blob"
                });
              })
              .then(resp => {
                console.log(resp)
                const blob = new Blob([resp.data], { type: 'application/pdf' })
                var fileURLNew = URL.createObjectURL(blob);
                console.log(fileURLNew)
                window.open(fileURLNew, '_blank');
                handleClosePreview()
                connectClose()
                window.location.reload();
              });
            }).catch(error => {
              console.error(error);
            });
          })
          .catch((error) => {
            console.log(error.message);
            setError(error.response.data.message)
          });
        }
      setLoading(false)
      handleCloseNewCompany()
      handleCloseNoTelp()
    }
    
    
    const [loading, setLoading] = useState(false); // Define loading state
    const handleMouseEnter = () => {
        setIsHovered(true);
      };
    
      const handleMouseLeave = () => {
        setIsHovered(false);
      };
    

      const handleMouseEnterCompany = () => {
        setIsHoveredCompany(true);
      };
      const [noNib,setNoNIB]=useState()
      const [akte, setAkte]=useState()
      const handleMouseLeaveCompany = () => {
        setIsHoveredCompany(false);
      };
    
      const selectTipePerusahaan = (event) => {
        setTipePerusahaan(event.target.value)
      }

      const handleIconClickCompany = () => {
        // handle search logic here
        console.log("Search clicked");
      };

      const styles = {
        container: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "8px",
          borderRadius: "4px",
          position: "relative",
        },
        text: {
          color: "rgba(0, 0, 0, 1)",
          visibility: "visible",
        },
        iconButton: {
          color: "#fff",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          visibility: "hidden",
          zIndex: 1,
        },
      };
      const [openNoTelp, setOpenNoTelp] = useState(false);

      const newNoTelp = () => {
        console.log("here")
        setOpenNoTelp(true);
    };
  

        
    return <Grid sx={{p:5}}>
              <Dialog open={loading} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                {error && <div className="error_text">{error}</div>}
            <Grid container>
                <Grid sm={5}> 
                    <p>Tipe:</p>
                </Grid>
                <Grid sm={7}>
                  <Select  fullWidth value={tipePerusahaan} onChange={event => selectTipePerusahaan(event)}><MenuItem value="PT">PT.</MenuItem><MenuItem value="CV">CV.</MenuItem><MenuItem value="Yayasan">Yayasan</MenuItem><MenuItem value="Koperasi">Koperasi</MenuItem></Select>
                </Grid>
            </Grid>
            <Grid container sx={{mt:5}}>
                <Grid sm={5}> 
                    <p>Nama Perusahaan:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField onChange={event => handleNamaPerusahaan(event)}></TextField>
                </Grid>
            </Grid>
            <Grid container sx={{mt:2}}>

                <Grid sm={5}> 
                    <p>Industri:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField onChange={event => handleIndustri(event)}></TextField>
                </Grid>
            </Grid>
            <Divider style={{ height: '1px', backgroundColor:"lightgrey"}} sx={{my:5}} />

            <Grid container sx={{mt:2, mb:5}}>

                <Grid sm={5}> 
                    <p>NPWP PT:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField onChange={event => handleNPWP(event)}></TextField>
                </Grid>
            </Grid>
             <Grid container sx={{mt:2, mb:5}}>

                <Grid sm={5}> 
                    <p>No. Akte:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField value={akte} onChange={event => setAkte(event)}></TextField>
                </Grid>
            </Grid>
             <Grid container sx={{mt:2, mb:5}}>

                <Grid sm={5}> 
                    <p>NIB/SIUP:</p>
                </Grid>
                <Grid sm={7}>
                    <TextField value={noNib} onChange={event => setNoNIB(event)}></TextField>
                </Grid>
            </Grid>

            <Button type="button" variant="contained" onClick={saveCompany}>Save & Use</Button>
            <RedButton type="button" variant="contained" onClick={connectClose}>Cancel</RedButton>

</Grid>    };